import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/auto-callout-board/')({
    head: () => ({
        meta: [{ title: 'Auto-callout Board | Phoebe Admin' }],
    }),
});
